<template>
  <div class="p-3 pb-3 dd bg-primary">
    <b-overlay :show="loading">
      <b-tabs
        content-class="mt-3"
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        active-tab-class="font-weight-bold text-success"
        fill
      >
        <b-tab :title="$t('photoCan')" active class="text-center">
          <div class="table-white">
            <b-form-file
              ref="photoRef"
              style="width: 50%"
              accept=".pdf, image/*"
              :class="employee.employeePhotoUploadPath ? 'd-none' : ''"
              class="mt-3"
              :browse-text="$t('actions.choose_file')"
              v-model="photo"
              :placeholder="$t('actions.uploadImage')"
              :drop-placeholder="$t('photoCan')"
            ></b-form-file>

            <div class="alert bg-white" style="width: 100%; border: 1px solid white">
              <div
                class="claerfix"
                v-if="employee.employeePhotoUploadPath"
                style="display: flex; align-items: center; justify-content: space-between"
              >
                <div style="display: flex; align-items: center">
                  <div class="mr-2">
                    <img
                      style="object-fit: contain"
                      width="80"
                      height="80"
                      :src="
                        employee.employeePhotoExtension == 'doc' ||
                        employee.employeePhotoExtension == 'docx' ||
                        employee.employeePhotoExtension == 'DOC' ||
                        employee.employeePhotoExtension == 'DOCX'
                          ? require('@/assets/images/word.png')
                          : employee.employeePhotoExtension == 'pdf' ||
                            employee.employeePhotoExtension == 'PDF'
                          ? require('@/assets/images/pdf.png')
                          : `${baseUrl}/${employee.employeePhotoUploadPath}`
                      "
                    />
                  </div>
                  <div>
                    <h3 class="alert-title">{{ employee.employeePhotoName }}</h3>
                  </div>
                </div>

                <div class="d-flex align-items-center">
                  <b-button
                    tag="a"
                    :href="`${baseUrl}/${employee.employeePhotoUploadPath}`"
                    :download="`${employee.employeePhotoName}`"
                    target="_blank"
                    variant="light"
                    class="text-black mr-2 py-2"
                    size="sm"
                  >
                    <i class="fa fa-download text-primary"></i>
                  </b-button>
                  <b-button variant="light" @click="editFile('photoRef')">
                    <i class="fa fa-pen text-primary"></i>
                  </b-button>
                  <b-button
                    @click="getPhotoArchive"
                    variant="light"
                    class="float-right ml-3"
                  >
                    <i class="fa fa-archive text-primary"></i>
                    {{ $t("archive") }}
                  </b-button>
                </div>
              </div>
            </div>
            <div v-if="photoArchivesShow">
              <div class="text-left text-light">{{ $t("archiveInfo") }}</div>
              <b-overlay blur="50px" :show="loading">
                <file-show :fileList="photoArchives"></file-show>
              </b-overlay>
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('employees.passport')" class="text-center">
          <b-form-file
            ref="copyRef"
            accept=".pdf, .doc, .docx, image/*"
            :class="employee.employeePassportScannerUploadPath ? 'd-none' : ''"
            class="mt-3"
            style="width: 50%"
            :browse-text="$t('actions.choose_file')"
            v-model="copy"
            :placeholder="$t('actions.uploadCopy')"
            :drop-placeholder="$t('photoCan')"
          ></b-form-file>

          <div
            v-if="employee.employeePassportScannerUploadPath"
            class="alert bg-white"
            style="width: 100%; border: 1px solid white"
          >
            <div
              style="display: flex; align-items: center; justify-content: space-between"
            >
              <div style="display: flex; align-items: center">
                <div class="mr-2">
                  <img
                    style="object-fit: contain"
                    width="80"
                    height="80"
                    :src="
                      employee.employeePassportScannerType == 'doc' ||
                      employee.employeePassportScannerType == 'docx' ||
                      employee.employeePassportScannerType == 'DOC' ||
                      employee.employeePassportScannerType == 'DOCX'
                        ? require('@/assets/images/word.png')
                        : employee.employeePassportScannerType == 'pdf' ||
                          employee.employeePassportScannerType == 'PDF'
                        ? require('@/assets/images/pdf.png')
                        : `${baseUrl}/${employee.employeePassportScannerUploadPath}`
                    "
                  />
                </div>
                <div>
                  <h3 class="alert-title">
                    {{ employee.employeePassportScannerName }}
                  </h3>
                </div>
              </div>
              <div>
                <b-button
                  tag="a"
                  :href="`${baseUrl}/${employee.employeePassportScannerUploadPath}`"
                  :download="`${employee.employeePassportScannerName}`"
                  target="_blank"
                  variant="light"
                  class="text-black mr-2 py-2"
                  size="sm"
                >
                  <i class="fa fa-download text-primary"></i>
                </b-button>
                <b-button variant="light" @click="editFile('copyRef')">
                  <i class="fa fa-pen text-primary"></i>
                </b-button>
                <b-button
                  @click="getPassportArchive"
                  variant="light"
                  class="float-right ml-3"
                >
                  <i class="fa fa-archive text-primary"></i>
                  {{ $t("archive") }}
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="passportArchivesShow">
            <div class="text-left text-light">{{ $t("archiveInfo") }}</div>
            <b-overlay blur="50px" :show="loading">
              <file-show class="mt-3" :fileList="passportArchives"></file-show>
            </b-overlay>
          </div>
        </b-tab>
        <b-tab :title="$t('references.education')" class="text-center">
          <b-form-file
            ref="diplomRef"
            accept=".pdf, .doc, .docx, image/*"
            :class="employee.employeeDiplomaUploadPath ? 'd-none' : ''"
            class="mt-3"
            style="width: 50%"
            :browse-text="$t('actions.choose_file')"
            v-model="diplom"
            :placeholder="$t('actions.uploadDiplom')"
            :drop-placeholder="$t('photoCan')"
          ></b-form-file>

          <div
            v-if="employee.employeeDiplomaUploadPath"
            class="alert bg-white"
            style="width: 100%; border: 1px solid white"
          >
            <div
              style="display: flex; align-items: center; justify-content: space-between"
            >
              <div style="display: flex; align-items: center">
                <div class="mr-2">
                  <img
                    width="80"
                    height="80"
                    style="object-fit: contain"
                    :src="
                      employee.employeeDiplomaType == 'doc' ||
                      employee.employeeDiplomaType == 'docx' ||
                      employee.employeeDiplomaType == 'DOC' ||
                      employee.employeeDiplomaType == 'DOCX'
                        ? require('@/assets/images/word.png')
                        : employee.employeeDiplomaType == 'pdf' ||
                          employee.employeeDiplomaType == 'PDF'
                        ? require('@/assets/images/pdf.png')
                        : `${baseUrl}/${employee.employeeDiplomaUploadPath}`
                    "
                  />
                </div>
                <div>
                  <h3 class="alert-title">{{ employee.employeeDiplomaName }}</h3>
                </div>
              </div>
              <div>
                <b-button
                  tag="a"
                  :href="`${baseUrl}/${employee.employeeDiplomaUploadPath}`"
                  :download="`${employee.employeeDiplomaName}`"
                  target="_blank"
                  variant="light"
                  class="text-black mr-2 py-2"
                  size="sm"
                >
                  <i class="fa fa-download text-primary"></i>
                </b-button>
                <b-button variant="light" @click="editFile('diplomRef')">
                  <i class="fa fa-pen text-primary"></i>
                </b-button>
                <b-button
                  @click="getDiplomArchive"
                  variant="light"
                  class="float-right ml-3"
                >
                  <i class="fa fa-archive text-primary"></i>
                  {{ $t("archive") }}
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="diplomArchivesShow">
            <div class="text-left text-light">{{ $t("archiveInfo") }}</div>
            <b-overlay blur="50px" :show="loading">
              <file-show :fileList="diplomArchives"></file-show>
            </b-overlay>
          </div>
        </b-tab>
        <b-tab :title="$t('employees.ob')" class="text-center">
          <div style="width: 100%" class="d-flex">
            <div style="width: 50%"></div>
            <div class="alert p-0 pl-4 bg-white" style="width: 100%">
              <div
                style="display: flex; align-items: center; justify-content: space-between"
              >
                <div>
                  <!-- <div class="mr-2">
                <img
                  width="40"
                  height="40"
                  :src="require('@/assets/images/word.png')"
                />
              </div> -->
                  <div>
                    <h3 class="alert-title">{{ $t("obnamuna") }}</h3>
                  </div>
                </div>
                <div class="flex-container">
                  <a @click="downloadNamuna" class="text-dark" style="cursor: pointer">
                    <i class="fa fa-download"></i>
                    {{ $t("actions.download") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <b-form-file
            ref="obRef"
            accept=".pdf, .doc, .docx, image/*"
            :class="employee.resumeUploadPath ? 'd-none' : ''"
            class="mt-3"
            style="width: 50%"
            :browse-text="$t('actions.choose_file')"
            v-model="ob"
            :placeholder="$t('actions.uploadObyektivka')"
          ></b-form-file>

          <div
            v-if="employee.resumeUploadPath"
            class="alert bg-white"
            style="width: 100%; border: 1px solid white"
          >
            <div
              style="display: flex; align-items: center; justify-content: space-between"
            >
              <div style="display: flex; align-items: center">
                <div class="mr-2">
                  <img
                    width="80"
                    height="80"
                    style="object-fit: contain"
                    img="
                    employee.resumeType == 'doc' ||
                    employee.resumeType == 'docx' ||
                    employee.resumeType == 'DOCX' ||
                    employee.resumeType == 'DOC'
                      ? require('@/assets/images/word.png')
                      : employee.resumeType == 'pdf' ||
                        employee.resumeType == 'PDF'
                      ? require('@/assets/images/pdf.png')
                      : `${baseUrl}/${employee.resumeUploadPath}`
                  "
                  />
                </div>
                <div>
                  <h3 class="alert-title">{{ employee.resumeName }}</h3>
                </div>
              </div>
              <div>
                <b-button
                  tag="a"
                  :href="`${baseUrl}/${employee.resumeUploadPath}`"
                  :download="`${employee.resumeName}`"
                  target="_blank"
                  variant="light"
                  class="text-black mr-2 py-2"
                  size="sm"
                >
                  <i class="fa fa-download text-primary"></i>
                </b-button>
                <b-button variant="light" @click="editFile('obRef')">
                  <i class="fa fa-pen text-primary"></i>
                </b-button>
                <b-button @click="getObArchive" variant="light" class="float-right ml-3">
                  <i class="fa fa-archive text-primary"></i>
                  {{ $t("archive") }}
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="obArchivesShow">
            <div class="text-left text-light">{{ $t("archiveInfo") }}</div>
            <b-overlay blur="50px" :show="loading">
              <file-show :fileList="obArchives"></file-show>
            </b-overlay>
          </div>
        </b-tab>

        <b-tab :title="$t('recruitment.additionalData')">
          <div class="text-center p-2">
            <b-button @click="isOtherFile = true" variant="light">
              <i class="fa fa-upload"></i>
              {{ $t("additionalDoc") }}
            </b-button>
          </div>

          <b-form-file
            ref="otherRef"
            accept=".pdf, .doc, .docx, image/*"
            :browse-text="$t('actions.choose_file')"
            style="width: 50%; display: none"
            v-model="other"
            :placeholder="$t('additionalDoc')"
          ></b-form-file>
          <div
            class="alert bg-white both-clear"
            style="width: 100%; border: 1px solid white"
            v-for="(v, index) in otherFiles"
            :key="index"
          >
            <div
              style="display: flex; align-items: center; justify-content: space-between"
            >
              <div style="display: flex; align-items: center">
                <div class="mr-2">
                  <img
                    width="80"
                    height="80"
                    style="object-fit: contain"
                    img="
                    v.fileType == 'doc' ||
                    v.fileType == 'docx' ||
                    v.fileType == 'DOC' ||
                    v.fileType == 'DOCX'
                      ? require('@/assets/images/word.png')
                      : v.fileType == 'pdf' || v.fileType == 'PDF'
                      ? require('@/assets/images/pdf.png')
                      : `${baseUrl}/${v.uploadPath}`
                  "
                  />
                </div>
                <div>
                  <h3 class="alert-title">{{ v.name }}</h3>
                </div>
              </div>

              <div>
                <b-button
                  variant="light"
                  class="btn btn-icon"
                  @click="deleteOtherfiles(v)"
                >
                  <i class="fa fa-trash" style="color: red"></i>
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="addArchivesShow">
            <div class="text-left text-light">{{ $t("archiveInfo") }}</div>
            <b-overlay blur="50px" :show="loading">
              <file-show :fileList="addArchives"></file-show>
            </b-overlay>
          </div>
        </b-tab>
      </b-tabs>
    </b-overlay>

    <b-modal
      size="md"
      :no-close-on-backdrop="true"
      :title="$t('nameDoc')"
      :ok-title="$t('actions.save')"
      :cancel-title="$t('actions.cancel')"
      @close="isOtherFile = false"
      @cancel="isOtherFile = false"
      @ok="okOtherFile"
      v-model="isOtherFile"
    >
      <b-form-input v-model="name"></b-form-input>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :hide-header="true"
      :ok-title="$t('actions.delete')"
      :cancel-title="$t('actions.cancel')"
      @close="cancel"
      @cancel="cancel"
      @ok="ok"
      v-model="deleteOtherfilesModal"
    >
      <p>{{ $t("confirm_delete") }}</p>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import pasportScanService from "@/services/pasportScan.service";
import photoService from "@/services/photo.service";
import DiplomService from "@/services/diplom.service";
import resumeService from "@/services/resume.service";
import otherService from "@/services/other.service";
import FileShow from "@/components/FileShow";
export default {
  async mounted() {
    await this.setOtherFile(this.employee.id);
  },
  data() {
    return {
      deleteOtherfilesModal: false,
      iddeleteOtherfiles: null,
      isOtherFile: false,
      photo: null,
      copy: null,
      diplom: null,
      ob: null,
      other: null,
      name: "",
      //
      photoArchives: [],
      photoArchivesShow: false,
      //
      passportArchives: [],
      passportArchivesShow: false,
      //
      diplomArchives: [],
      diplomArchivesShow: false,
      //
      obArchives: [],
      obArchivesShow: false,
      //
      addArchives: [],
      addArchivesShow: false,
      loading: false,
    };
  },
  computed: {
    ...mapState("employee", ["employee", "otherFiles"]),
    baseUrl() {
      return process.env.VUE_APP_ROOT_URL;
    },
  },
  components: {
    FileShow,
  },
  methods: {
    showError(e) {
      console.log(e);
      this.$toast.error(e.response.data.details[0]);
    },
    async getPhotoArchive() {
      this.loading = true;
      photoService
        .getPhotoArchive(this.employee.id)
        .then((res) => {
          this.photoArchives = res.data;
          this.photoArchivesShow = true;
          this.loading = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
          this.loading = false;
        });
    },
    async getPassportArchive() {
      this.loading = true;
      pasportScanService
        .getPassportArchive(this.employee.id)
        .then((res) => {
          this.passportArchives = res.data;
          this.passportArchivesShow = true;
          this.loading = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
          this.loading = false;
        });
    },
    async getDiplomArchive() {
      this.loading = true;
      DiplomService.getDiplomArchive(this.employee.id)
        .then((res) => {
          this.diplomArchives = res.data;
          this.diplomArchivesShow = true;
          this.loading = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
          this.loading = false;
        });
    },
    async getObArchive() {
      this.loading = true;
      resumeService
        .getResumeArchive(this.employee.id)
        .then((res) => {
          this.obArchives = res.data;
          this.obArchivesShow = true;
          this.loading = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
          this.loading = false;
        });
    },
    async getAddArchive() {
      this.loading = true;
      otherService
        .getOtherArchive(this.employee.id)
        .then((res) => {
          this.addArchives = res.data;
          this.obArchivesShow = true;
          this.loading = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
          this.loading = false;
        });
    },
    editFile(v) {
      if (this.$refs[v]) {
        this.$refs[v].$el.firstChild.click();
      }
    },
    ...mapActions("employee", ["getEmployee", "setOtherFile"]),
    deleteOtherfiles(value) {
      this.iddeleteOtherfiles = value.id;
      this.deleteOtherfilesModal = true;
    },
    cancel() {
      this.deleteOtherfilesModal = false;
      this.iddeleteOtherfiles = null;
    },
    async ok() {
      await otherService.deleteById(this.iddeleteOtherfiles);
      await this.setOtherFile(this.employee.id);
    },
    downloadNamuna() {
      resumeService.getObNamuna().then((rs) => {
        this.createLink(rs, "docx");
      });
    },
    createLink(res, type) {
      const url =
        type === "docx"
          ? URL.createObjectURL(
              new Blob([res.data], {
                type: "application/msword",
              })
            )
          : URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${this.$t("obnamuna")}.${type}`);
      document.body.appendChild(link);
      link.click();
    },
    selectOther() {
      this.$refs.otherRef.$el.firstChild.click();
    },
    async okOtherFile(s) {
      s.preventDefault();
      if (this.name != "" && this.name) {
        await this.selectOther();
        this.isOtherFile = false;
      } else {
        await this.$toast.error(this.$t("warning.enter"));
      }
    },
  },
  watch: {
    photo: {
      handler(file) {
        if (file) {
          this.loading = true;
          photoService
            .create(file, parseInt(this.employee.id))
            .then((res) => {
              this.$nextTick(async (res) => {
                this.photo = null;
                await this.getEmployee();
              });
            })
            .catch((e) => {
              this.showError(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
        this.photoArchivesShow = false;
      },
    },
    copy: {
      handler(file) {
        if (file) {
          this.loading = true
          pasportScanService
            .create(file, parseInt(this.employee.id))
            .then((res) => {
              this.$nextTick(async (res) => {
                await this.getEmployee();
                this.copy = null;
              });
            })
            .catch((e) => {
              this.copy = null
              this.showError(e);
            })
            .finally(()=>{
              this.loading = false
            })
          this.passportArchivesShow = false;
        }
      },
    },
    diplom: {
      handler(file) {
        if (file) {
          this.loading = true;
          DiplomService.create(file, parseInt(this.employee.id))
            .then((res) => {
              this.$nextTick(async (res) => {
                await this.getEmployee();
                this.diplom = null;
              });
            })
            .catch((e) => {
              this.showError(e);
            })
            .finally(() => {
              this.loading = false;
            });
          this.diplomArchivesShow = false;
        }
      },
    },
    ob: {
      handler(file) {
        if (file) {
          this.loading = true;
          resumeService
            .create(file, parseInt(this.employee.id))
            .then((res) => {
              this.$nextTick(async (res) => {
                await this.getEmployee();
                this.ob = null;
              });
            })
            .catch((e) => {
              this.showError(e);
            })
            .finally(() => {
              this.loading = false;
            });
          this.obArchivesShow = false;
        }
      },
    },
    other: {
      handler(file) {
        this.loading = true;
        otherService
          .create(file, {
            employeeId: parseInt(this.employee.id),
            name: this.name,
          })
          .then((res) => {
            this.name = "";
            this.setOtherFile(this.employee.id);
          })
          .catch((e) => {
            this.showError(e);
          })
          .finally(() => {
            this.loading = false;
          });
        this.obArchivesShow = false;
      },
    },
  },
};
</script>

<style lang="scss">
.dd {
  a {
    color: white;
    font-size: 16px;
    padding: 15px;
  }
}

$success-color: #2ec946;

.alert {
  padding: 16px;
  margin: 8px;
}

@mixin alert-2($color) {
  border-left: 4px solid $color;
  background-color: rgba($color, 0.05);

  .alert-title {
    color: $color;
  }
}

.alert-2-success {
  @include alert-2($success-color);
}

.alert-title {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 18px;
  font-family: "Poppins", sans-serif;
}

.alert-content {
  margin: 0;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #555555;
}
</style>
